/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'

export const _2 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>2 - Стадия монтирования</h2>
    <p className={styles.description}>
      Следующие методы вызываются когда создается экземпляр компонента и добавляется в DOM.{' '}
    </p>
    <CopyBlock text={`constructor() {}`} language="javascript" showLineNumbers={false} theme={ocean} />
    <p className={styles.description}>
      Вызывается в момент создания экземпляра компонента, до того как компонент будет помещен в DOM.{' '}
    </p>
    <ul className={styles.list}>
      <li className={styles.list__item}>Инициализирует начальное состояние компонента</li>
      <li className={styles.list__item}>Привязывает контекст в методах</li>
      <li className={styles.list__item}>
        Нельзя вызывать <code className={styles.code}>setState()</code>
      </li>
      <li className={styles.list__item}>В большинстве случаев явное указание конструтора излишне</li>
    </ul>
    <CopyBlock
      text={`static getDerivedStateFromProps(nextProps, prevState) {}`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
    <ul className={styles.list}>
      <li className={styles.list__item}>
        Вызывается перед <code className={styles.code}>render()</code>, при монтировании и перед всеми последующими
        вызовами <code className={styles.code}>render</code>, тоесть после обновления{' '}
        <code className={styles.code}>state</code> или <code className={styles.code}>props</code>.
      </li>
      <li className={styles.list__item}>
        Можно использовать для того чтобы установить <code className={styles.code}>state</code> в зависимости от{' '}
        <code className={styles.code}>props</code> при каждом их изменении.
      </li>
      <li className={styles.list__item}>
        Должен вернуть объект, которым будет обновлено состояние, или <code className={styles.code}>null</code> если
        ничего обновлять не нужно.
      </li>
      <li className={styles.list__item}>
        Нут доступа к <code className={styles.code}>this</code>
      </li>
    </ul>
    <CopyBlock text={`render() {}`} language="javascript" showLineNumbers={false} theme={ocean} />
    <ul className={styles.list}>
      <li className={styles.list__item}>Позволяет декларативно описать интерфейс</li>
      <li className={styles.list__item}>Возвращает результат JSX-выражений, поддерево Virtual DOM</li>
      <li className={styles.list__item}>
        Нельзя вызывать <code className={styles.code}>setState()</code>
      </li>
    </ul>
    <CopyBlock text={`componentDidMount() {}`} language="javascript" showLineNumbers={false} theme={ocean} />
    <ul className={styles.list}>
      <li className={styles.list__item}>Вызывается сразу после монтирования в DOM</li>
      <li className={styles.list__item}>
        Делаем HTTP-запросы, вешаем кастомные слушатели событий и делаем операции с DOM
      </li>
      <li className={styles.list__item}>
        Вызов <code className={styles.code}>setState()</code> в этом методе, вызовет ре-рендер - это нормально
      </li>
    </ul>
  </section>
))
